import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { breadcrumbJsonLd } from './Seo';

export function Breadcrumbs({ items }) {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd(items))}</script>
      </Helmet>
      <nav aria-label="Brotkrumennavigation" className="container-site pt-6">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-brand-brown-soft">
          {items.map((item, i) => {
            const last = i === items.length - 1;
            return (
              <li key={`${item.label}-${i}`} className="flex items-center gap-2">
                {i > 0 && <span aria-hidden="true" className="text-brand-gold">›</span>}
                {last || !item.href ? (
                  <span aria-current="page" className="font-semibold text-brand-brown">{item.label}</span>
                ) : (
                  <Link to={item.href} className="rounded-sm underline decoration-brand-gold/50 underline-offset-4 transition-colors duration-200 hover:text-brand-olive">
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
